import { MathUtils } from '../../../../shared/utils/MathUtils.ts';
import { GameColor } from '@colonist/ui-game';
import { createDivIn } from '../../../shared/scripts/ui_utils/DomUtils.ts';
export class UIProfileRankedProgressBarController {
    calculateProgressPercentage() {
        const lowerBound = this.seasonProgress.demotionDivisionBoundary.boundary;
        const upperBound = this.seasonProgress.promotionDivisionBoundary.boundary;
        const percentage = MathUtils.calculatePercentage(Number(this.currentSkill), lowerBound, upperBound);
        return percentage;
    }
    fillProgressBar(percentage) {
        this.progressBarDiv.style.width = `${percentage}%`;
        this.progressBarDiv.style.backgroundColor = GameColor.getColor(GameColor.Color.GreenDark);
    }
    constructor(seasonProgress, currentSkill, progressContainerDiv){
        this.progressBarIdBase = 'ranked_progress_bar';
        this.seasonProgress = seasonProgress;
        this.currentSkill = currentSkill;
        this.progressBarContainerDiv = createDivIn(progressContainerDiv, `${this.progressBarIdBase}_container`);
        this.progressBarDiv = createDivIn(this.progressBarContainerDiv, this.progressBarIdBase);
        const percentage = this.calculateProgressPercentage();
        this.fillProgressBar(percentage);
    }
}
